import React from "react";
import { CompareProps, useCompare } from "properties/propertyCard/components/favorite/compare-provider";
import { useTranslation } from "react-i18next";
import CompareModalGoback from "properties/compare/modal/compare-modal-goback";
import CompareModalTable from "properties/compare/modal/compare-modal-table";

interface Props {
    items: CompareProps[];
}
export default function CompareModalContentProperty({ items }: Props) {
    const { closeModal } = useCompare();
    const { t } = useTranslation();

    return (
        <div className="p-5 md:p-10">
            <CompareModalGoback closeModal={closeModal} />
            <h2 className="text-2xl font-medium text-[#1A3A45]">{t("propertiesPage.compare")}</h2>
            <CompareModalTable selectedItems={items} />
        </div>
    );
}
